import { isInternalLink } from './isInternalLink';
import type {
  InternalLinkProps,
  ExternalLinkProps,
  NonNavigatingProps,
  ResolvedLinkProps,
  ResolvedLink,
  ResolveLinkOptions,
} from './resolveLinkProps.types';

export type {
  InternalLinkProps,
  ExternalLinkProps,
  NonNavigatingProps,
  ResolvedLinkProps,
  ResolvedLink,
  ResolveLinkOptions,
};

export const resolveLinkProps = (options: ResolveLinkOptions): ResolvedLinkProps => {
  const { url, baseUrl, blank } = options;

  if (!url) {
    return {} as NonNavigatingProps;
  }

  const { isInternal, relativeLink } = isInternalLink(baseUrl, url);

  if (isInternal) {
    if (blank) {
      return {
        href: `${baseUrl}${relativeLink}`,
        target: '_blank' as const,
        rel: 'noopener noreferrer',
      };
    }
    return { to: relativeLink };
  }

  if (blank) {
    return {
      href: url,
      target: '_blank' as const,
      rel: 'noopener noreferrer',
    };
  }

  return { href: url };
};

export const isResolvedInternal = (props: ResolvedLinkProps): props is InternalLinkProps =>
  'to' in props && typeof (props as InternalLinkProps).to === 'string';

export const resolveLink = (options: ResolveLinkOptions): ResolvedLink => {
  const linkProps = resolveLinkProps(options);
  if (isResolvedInternal(linkProps)) {
    return { isInternal: true, linkProps };
  }
  return { isInternal: false, linkProps };
};

/** CMS mega menu / global nav: internal vs external, and open-in-new-tab for external only. */
export type MegamenuLinkFields = { type?: string; slug?: string; blank?: boolean };

export const getMegamenuLinkNav = (
  data: MegamenuLinkFields | undefined,
  baseUrl: string,
): { isInternal: boolean; openInBlank: boolean } => {
  const isInternal = data?.type === 'internalLink' || resolveLink({ url: data?.slug, baseUrl }).isInternal;
  return {
    isInternal,
    openInBlank: !isInternal && !!data?.blank,
  };
};
